/**
 * Placeholder rendering of the DGOS geology report page.
 * Swap this for a real PDF viewer (e.g. pdf.js) once the documents API is wired up.
 */

const FORMATION_TOPS = [
  ['Top I', '693.0', '693.0', '663.0', '698.0', '698.0', '666.9', '3.9'],
  ['Top J', '1419.0', '1419.0', '1389.0', '1407.3', '1407.3', '1376.2', '-12.8'],
  ['Top K-Shale', '1794.0', '1794.0', '1764.0', '1822.0', '1821.8', '1790.7', '26.7'],
  ['K-28', '2275.0', '2275.0', '2245.0', '2287.0', '2287.0', '2255.9', '10.9'],
  ['K-30**', '2353.0', '2353.0', '2323.0', '2353.0', '2353.0', '2321.9', '-1.1'],
  ['K-35**', '2417.0', '2417.0', '2387.0', '2402.0', '2402.0', '2370.9', '-16.1'],
  ['K-40/50**', '2461.0', '2461.0', '2431.0', '2466.2', '2466.2', '2435.1', '4.1'],
  ['Top L-Shale', '2541.0', '2541.0', '2511.0', '2506.0', '2505.2', '2474.1', '-36.9'],
  ['L-60*', '2619.0', '2619.0', '2589.0', '2643.0', '2642.1', '2611.0', '23.0'],
  ['L-80*', '2732.0', '2732.0', '2702.0', '—', '—', '—', '—'],
  ['FTD', '3135.0', '3135.0', '3105.0', '—', '—', '—', '—'],
];

const GAS_COLUMNS = [
  'Depth\nm MD',
  'BG Gas\n(%)',
  'Type',
  'Gas Peak\n(%)',
  'C1\n(ppm)',
  'C2\n(ppm)',
  'C3\n(ppm)',
  'iC4\n(ppm)',
  'nC4\n(ppm)',
  'iC5\n(ppm)',
  'nC5\n(ppm)',
  'nC6\n(ppm)',
  'nC7\n(ppm)',
  'nC8\n(ppm)',
  'CO2\n(%)',
  'Lithology',
];

const MNEMONICS = [
  ['assy', 'assembly', 'BG', 'background gas', 'BHA', 'bottom hole assembly'],
  ['C/O', 'change out', 'CBU', 'circulate bottoms up', 'CCL', 'casing collar locator'],
  ['CRT', 'casing running tool', 'csg', 'casing', 'drlg', 'drilling'],
  ['f/', 'from', 'FIT', 'formation integrity test', 'fm', 'formation'],
  ['LOT', 'leak off test', 'M/U', 'make up', 'PDG', 'permanent downhole gauge'],
];

export function GeologyReport({ title }: { title: string }) {
  return (
    <article className="paper" aria-label={title}>
      <table className="geo-table">
        <thead>
          <tr>
            <th>Formation</th>
            <th>Prog MD</th>
            <th>Prog TVD</th>
            <th>Prog TVDSS</th>
            <th>Act MD</th>
            <th>Act TVD</th>
            <th>Act TVDSS</th>
            <th>Diff</th>
            <th className="geo-remark">Remarks</th>
          </tr>
        </thead>
        <tbody>
          {FORMATION_TOPS.map((row) => (
            <tr key={row[0]}>
              {row.map((cell, i) => (
                <td key={i} className={i === 0 ? 'geo-name' : 'geo-num'}>
                  {cell}
                </td>
              ))}
              <td className="geo-remark">Preliminary by WSG</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 className="paper-band">LITHOLOGY</h3>
      <table className="geo-table">
        <thead>
          <tr>
            <th colSpan={2}>Interval (mMD)</th>
            <th>%</th>
            <th className="geo-remark">Descriptions</th>
          </tr>
          <tr>
            <th>From</th>
            <th>To</th>
            <th />
            <th />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="geo-num">2541.0</td>
            <td className="geo-num">2673.4</td>
            <td className="geo-num">100</td>
            <td className="geo-remark">
              Claystone, medium grey, soft to firm, sub-blocky, silty in part.
            </td>
          </tr>
        </tbody>
      </table>

      <h3 className="paper-band">GAS SHOW</h3>
      <table className="geo-table geo-table--dense">
        <thead>
          <tr>
            {GAS_COLUMNS.map((c) => (
              <th key={c}>
                {c.split('\n').map((line, i) => (
                  <span key={i} className="th-line">
                    {line}
                  </span>
                ))}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="geo-num">2650.0</td>
            <td className="geo-num">0.42</td>
            <td>BG</td>
            <td className="geo-num">1.18</td>
            <td className="geo-num">3820</td>
            <td className="geo-num">412</td>
            <td className="geo-num">128</td>
            <td className="geo-num">31</td>
            <td className="geo-num">44</td>
            <td className="geo-num">12</td>
            <td className="geo-num">9</td>
            <td className="geo-num">4</td>
            <td className="geo-num">2</td>
            <td className="geo-num">1</td>
            <td className="geo-num">0.31</td>
            <td>Claystone</td>
          </tr>
        </tbody>
      </table>

      <h3 className="paper-band">MNEMONICS - OPERATION</h3>
      <table className="geo-table geo-table--mnemonic">
        <tbody>
          {MNEMONICS.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j} className={j % 2 === 0 ? 'geo-name' : ''}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </article>
  );
}
